import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { finalize, map, Observable, of, Subject } from 'rxjs';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { DocumentePubliceService } from './documente-publice.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import Swal from 'sweetalert2';
import { AddDocumentePubliceComponent } from './add-documente-publice/add-documente-publice.component';
import { EditDocumentePubliceComponent } from './edit-documente-publice/edit-documente-publice.component';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { DirectiiService } from '../../settings-sidenav/directii/directii.service';
import { CompartimenteService } from '../../settings-sidenav/compartimente/compartimente.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { FormControl, FormGroup } from '@angular/forms';
import { UsersService } from '../../settings-sidenav/users-settings/users.service';
import { AniService } from '../institutii-settings/ani/ani.service';
import { TipuriDocumenteService } from '../institutii-settings/tipuri-documente/tipuri-documente.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-documente-publice',
    templateUrl: './documente-publice.component.html',
    styleUrls: ['./documente-publice.component.scss']
})
export class DocumentePubliceComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.documentePublice.getDocumenteDT;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    defaultParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    directiiActive$!: Generic[];
    compartimenteActive$!: Observable<Generic[]>;
    aniList!: Generic[];
    tipuriDocumente!: Generic[];
    userTypes$!: Generic[];

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        id_directie: -1,
        id_compartiment: -1,
        type: '-1',
        name: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            id_directie: new FormControl(-1),
            id_compartiment: new FormControl(-1),
            type: new FormControl('-1'),
            name: new FormControl(''),
        });
    }

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private documentePubliceService: DocumentePubliceService,
        public permissionsService: PermissionsService,
        private directiiService: DirectiiService,
        private compartimenteService: CompartimenteService,
        private usersService: UsersService,
        private aniService: AniService,
        private tipuriDocumenteService: TipuriDocumenteService,
        private breakpointObserver: BreakpointObserver,

    ) { }

    ngOnInit(): void {
        // this.renderDT();
        this.buildSearchParamsForm();
        this.loadDirectiiActive();
        this.loadAniActive();
        this.loadTipuriDocumenteActive();
        this.loadUserTypes();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public_visible = this.publicValue;

                this.isLoading = true;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Status',
                    data: 'name',
                    render: (data: any, type: any, row: any) => {
                        const bgColor = row.bg_color || '';
                        return `<span style="background-color: ${bgColor}; color: white; border-radius: 4px; padding: 3px 10px">${data}</span>`;
                    },
                },
                {
                    title: 'Rank',
                    data: 'rank_name',
                },
                {
                    title: 'Order',
                    data: null,
                    sortable: true,
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `<div class="order-section-dt"> 
                                            <button type="button" class="action-btn up-order btn btn-sm btn-primary" ${row.order == 0 ? 'disabled="true"' : ''
                            } (click)="updateStatusOrder(${row.id}, -1)" title="Downside - -1">
                                                <img class="btn-img" src="/assets/icons/down-white.svg" alt="down-order"/>
                                            </button>
                                            <span class="order">${row.order}</span>
                                            <button type="button" class="action-btn down-order btn btn-sm btn-primary" (click)="updateStatusOrder(${row.id}, 1)" title="Up - +1">
                                                <img class="btn-img" src="/assets/icons/up-white.svg" alt="up-order"/>
                                            </button>
                                        </div>`
                        );
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (row: any) => {
                        return `
                                        <div class="d-flex align-center justify-content-left">
                                            <button class="action-btn edit ms-1">
                                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                                            </button>
                                            <button class="action-btn delete ms-1">
                                                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                                            </button>
                                            <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.active == true ? 'action-success' : 'action-danger') +
                            `">
                                                    <img class="btn-img" src="` +
                            (row.active == true
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `" alt="update_status_active"/>
                                            </button>
                                            <button type="button" class="action-btn update_status_public ms-1 ` +
                            (row.public_visible == true
                                ? 'action-success'
                                : 'action-danger') +
                            `">
                                                <img class="btn-img" src="` +
                            (row.public_visible == true
                                ? '/assets/icons/public_white.svg'
                                : '/assets/icons/public_not_white.svg') +
                            `" alt="update_status_public"/>
                                            </button>
                                        </div>
                                    `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const orderTD = (row as HTMLElement).querySelector('td:nth-child(4)');
                const upOrderInSection = orderTD?.querySelector(
                    '.up-order'
                ) as HTMLElement;
                const downOrderInSection = orderTD?.querySelector(
                    '.down-order'
                ) as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    '.update_status_public'
                ) as HTMLElement;


                if (editIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.update'
                    //     )
                    // ) {
                    //     editIcon.style.display = 'none';
                    // }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.delete'
                    //     )
                    // ) {
                    //     deleteIcon.style.display = 'none';
                    // }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteDocument(id);
                    });
                }

                if (upOrderInSection) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.order'
                    //     )
                    // ) {
                    //     upOrderInSection.style.display = 'none';
                    // }
                    upOrderInSection.addEventListener('click', () => {
                        const { id } = data;
                        this.updateStatusOrder(id, -1);
                    });
                }

                if (downOrderInSection) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.order'
                    //     )
                    // ) {
                    //     downOrderInSection.style.display = 'none';
                    // }
                    downOrderInSection.addEventListener('click', () => {
                        const { id } = data;
                        this.updateStatusOrder(id, 1);
                    });
                }

                if (updateStatusActiveIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.update-status'
                    //     )
                    // ) {
                    //     updateStatusActiveIcon.style.display = 'none';
                    // }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.cerere-settings.status.update-status'
                    //     )
                    // ) {
                    //     updateStatusActiveIcon.style.display = 'none';
                    // }
                    updateStatusPublicIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        // const dialogRef = this.dialog.open(AddDocumentePubliceComponent, {
        //     ...this.dialogService.getDialogConfig(),
        //     data: {
        //         directiiActive: this.directiiActive$,
        //         aniList: this.aniList,
        //         tipuriDocumente: this.tipuriDocumente,
        //         userTypes: this.userTypes$,
        //     }
        // });

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            autoFocus: false,
            data: {
                directiiActive: this.directiiActive$,
                aniList: this.aniList,
                tipuriDocumente: this.tipuriDocumente,
                userTypes: this.userTypes$,
            }
        };

        const dialogRef = this.dialog.open(AddDocumentePubliceComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', '55%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Document adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditDocumentePubliceComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                data: data,
                directiiActive: this.directiiActive$,
                aniList: this.aniList,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Document actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteDocument(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.documentePubliceService.deleteDocument(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: 'Șters!',
                        text: 'Cerere ștearsă cu succes.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                });
            }
        });
    }

    updateStatusOrder(id: number, index: number) {
        console.log(id, index, 'stuff?');

        this.isLoading = true;
        this.documentePubliceService.updateOrder(id, { index }).subscribe(
            () => {
                this.rerenderDT();
                // will need a toast here :) for good times :)
            },
            (err) => {
                this.rerenderDT();
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                });
            }
        );
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul funcției selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.documentePubliceService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Functie actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul funcției selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.documentePubliceService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Funcție actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;
        this.directiiService.getDirectiiActive().pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        ).subscribe({
            next: (results) => {
                this.directiiActive$ = results;
            },
            error: (err) => {
                console.error('Error in get directii active:', err);
            }
        })
    }

    onDirectieChange(directieId: number): void {
        this.searchParamsForm.controls['id_compartiment'].patchValue(-1);

        if (directieId == -1) {
            this.compartimenteActive$ = of([]);
            return;
        }

        if (directieId) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.compartimenteService.getCompartimenteByDirectieId(directieId)
            : this.compartimenteService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadAniActive() {
        this.isFilterLoading = true;

        this.aniService
            .getAniActive()
            .pipe(map((results) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false)))
            .subscribe({
                next: (results) => {
                    this.aniList = results;
                },
                error: (err) => {
                    console.error('Error in get ani list:', err);
                }
            });
    }

    loadTipuriDocumenteActive() {
        this.isFilterLoading = true;

        this.tipuriDocumenteService
            .getTipuriDocumenteActive()
            .pipe(map((results) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false)))
            .subscribe({
                next: (results) => {
                    this.tipuriDocumente = results;
                },
                error: (err) => {
                    console.error('Error in get tipuri documente:', err);
                }
            });
    }

    loadUserTypes() {
        this.isFilterLoading = true;

        this.usersService
            .getUserTypeActive()
            .pipe(map((results) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false)))
            .subscribe({
                next: (results) => {
                    this.userTypes$ = results;
                },
                error: (err) => {
                    console.error('Error in get user types:', err);
                }
            });
    }
}
